import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ILogoutResult extends IResult {
  redirectUrl: string;
}

export class LogoutRequest extends Request<{}, ILogoutResult> {
  constructor() {
    super('logout', {});
  }
}
